import { Stack } from '@mui/material';
import HeaderReaderMenu from './ReaderMenu/HeaderReaderMenu';

export default function ActionsMenu() {
  return (
    <Stack direction='row' sx={{ paddingX: 1.5 }}>
      <HeaderReaderMenu />
    </Stack>
  );
}
